import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import {
  EntityCardBlueprint,
  EntityContentBlueprint,
} from '@backstage/plugin-catalog-react/alpha';
import { RybbitClient, rybbitApiRef } from './api';
import { RYBBIT_SITE_ID_ANNOTATION } from './annotations';

/** Shown only where the entity names a Rybbit site. */
const hasSiteId = {
  [`metadata.annotations.${RYBBIT_SITE_ID_ANNOTATION}`]: { $exists: true },
};

const rybbitApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: rybbitApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new RybbitClient(discoveryApi, fetchApi),
    }),
});

const rybbitEntityContent = EntityContentBlueprint.make({
  params: {
    path: 'analytics',
    title: 'Analytics',
    filter: hasSiteId,
    loader: async () => {
      const { EntityRybbitContent } = await import(
        './components/EntityRybbitContent'
      );
      return <EntityRybbitContent />;
    },
  },
});

const rybbitEntityCard = EntityCardBlueprint.make({
  params: {
    type: 'info',
    filter: hasSiteId,
    loader: async () => {
      const { EntityRybbitCard } = await import(
        './components/EntityRybbitCard'
      );
      return <EntityRybbitCard />;
    },
  },
});

export const rybbitPlugin = createFrontendPlugin({
  pluginId: 'rybbit',
  extensions: [rybbitApi, rybbitEntityContent, rybbitEntityCard],
});
